import { premiumFeatures } from '../../common/constants/premium-features';

export default [
  premiumFeatures.DEFAULT,
  premiumFeatures.POINTED_DOMAIN,
  premiumFeatures.SITES_COUNT,
  premiumFeatures.CUSTOM_DOMAIN,
];
